import {createBottomTabNavigator} from '@react-navigation/bottom-tabs';
import {createStackNavigator} from '@react-navigation/stack';

import {AppRoutesNavigatorParamList} from '../models/navigationTypes';

const Tab = createBottomTabNavigator<AppRoutesNavigatorParamList>();
const Stack = createStackNavigator<AppRoutesNavigatorParamList>();

export {Stack, Tab};
